/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useUncontrolled as useUncontrolledImplementation } from 'uncontrollable';
import { deprecatedMsg } from './deprecatedMsg.js';

export const useUncontrolled = (...args: any[]) => {
  console.warn(`useUncontrolled ${deprecatedMsg}`);
  return useUncontrolledImplementation(...args);
};
